import { NEW_ROW_ID } from '@@/datatables/editable/EditableDatatable';

import {
  DockerRBACPolicyPayload,
  AccessPolicyValue,
  DockerRBACFormValues,
} from './types';

/**
 * Builds the API payload from form data
 * Returns only EnvironmentAccessPolicies (registry access handled separately)
 */
export function buildDockerRBACPayload(
  formData: Pick<DockerRBACFormValues, 'accessList'>
): DockerRBACPolicyPayload {
  const accessList = formData.accessList || [];

  const initial: {
    envUserAccessPolicies: Record<string, AccessPolicyValue>;
    envTeamAccessPolicies: Record<string, AccessPolicyValue>;
  } = { envUserAccessPolicies: {}, envTeamAccessPolicies: {} };

  const { envUserAccessPolicies, envTeamAccessPolicies } = accessList.reduce(
    (acc, access) => {
      // strip out incomplete data rows, should not get here past form validation
      if (
        access.Id === NEW_ROW_ID ||
        access.PartyId === null ||
        access.Role.Id === null ||
        access.Type === ''
      ) {
        return acc;
      }

      if (access.Type === 'user') {
        return {
          ...acc,
          envUserAccessPolicies: {
            ...acc.envUserAccessPolicies,
            [access.PartyId.toString()]: {
              RoleId: { value: access.Role.Id, enforce: false },
            },
          },
        };
      }

      if (access.Type === 'team') {
        return {
          ...acc,
          envTeamAccessPolicies: {
            ...acc.envTeamAccessPolicies,
            [access.PartyId.toString()]: {
              RoleId: { value: access.Role.Id, enforce: false },
            },
          },
        };
      }

      return acc;
    },
    initial
  );

  return {
    EnvironmentAccessPolicies: {
      UserAccessPolicies: envUserAccessPolicies,
      TeamAccessPolicies: envTeamAccessPolicies,
    },
  };
}
